import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import ListCalendarSchedule from "./ListCalendarSchedule";
import Placeholder from "../../components/Placeholder/PlaceholderByPage";

const ListCalendar = () => {
  const { t } = useTranslation();
  const { nextClasses } = useSelector((state) => state.genericReducer);

  return (
    <>
      <div className="listBox">
        {nextClasses.length > 0 ? (
          nextClasses.map((schedule) => (
            <ListCalendarSchedule key={schedule.id} schedule={schedule} isCalendar={true} />
          ))
        ) : (
          <Placeholder pageName="users" textMsg={t("NO_RESULTS")} />
        )}
      </div>
    </>
  );
};

export default ListCalendar;
